import React from "react";
import { useHistory } from "react-router-dom";
import { CompanyStatus } from "../../../../enums";
import { Api } from "../../../../services/api";
import { Company } from "../../../../services/api/types/Companies";
import { CompanyForm } from "../CompanyForm";
import {
  CompanyFormHeader,
  CompanyFormType,
} from "../CompanyForm/companyFormSchema";
import { ColumnContainer } from "../../Admin.styles";
import axios from "axios";
import { FormikHelpers } from "formik";

export const AddCompanyForm: React.FC<{}> = () => {
  const history = useHistory();

  const submitValues = (
    values: CompanyFormType,
    { setErrors }: FormikHelpers<CompanyFormType>
  ) => {
    const data: Partial<Company> = {
      status: CompanyStatus.Active, //Default to active
      name: values.name,
      address: values.address,
      entityId: values.entityId,
    };
    Api.companies
      .createCompany(data)
      .then(res => {
        const currentLocation = history.location;
        currentLocation.pathname =
          currentLocation.pathname.split("/").slice(0, -1).join("/") +
          `/${res.data.id}/edit`;
        history.push(currentLocation);
      })
      .catch((error: Error) => {
        if (
          axios.isAxiosError(error) &&
          error.response &&
          error.response.data.detail ===
            'duplicate key value violates unique constraint "companies_name_key"'
        ) {
          setErrors({ name: "Name already used" });
        } else {
          console.error("Create Company", error);
        }
      });
  };

  return (
    <ColumnContainer>
      <CompanyForm header={CompanyFormHeader.add} submitValues={submitValues} />
    </ColumnContainer>
  );
};
